const WORDS = ["MÉTODO ÚNICO", "RESULTADOS REAIS", "ACOMPANHAMENTO PREMIUM", "STUDIO PRIVATIVO", "TREINO SOB MEDIDA"];

export default function Marquee({ reverse = false }) {
  const items = [...WORDS, ...WORDS];
  return (
    <div className="relative w-full overflow-hidden border-y border-[--gold]/20 bg-[#080808] py-6">
      <div
        className={`flex w-max whitespace-nowrap ${reverse ? "animate-marquee-slow" : "animate-marquee"}`}
      >
        {items.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-4xl sm:text-6xl font-extrabold uppercase px-8 ${
                i % 2 === 0 ? "text-outline" : "text-[--gold]"
              }`}
            >
              {w}
            </span>
            <span className="text-[--gold] text-2xl">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
